module.exports = __webpack_public_path__ + "img/RDD-alt.9d3e98d2.svg";